import React from 'react'
import { Button, ButtonGroup } from 'rsuite'

import LegacyListIcon from '@rsuite/icons/legacy/List'
import { generatePath, Link, useParams } from 'react-router-dom'
import { ROUTE_ORDERS, ROUTE_ORDERS_FEEDBACKS, ROUTE_ORDERS_ON_MAP } from '@@partner:config/routes'
import ActiveOrdersOnMap from '@components/order/map/ActiveOrdersOnMap'
import OrdersPageTopMenu from '@components/order/OrdersPageTopMenu'


export default function ActiveOrdersOnMapPage () {
  const { brandSlug } = useParams<any>()
  

  return (
    <div className="OrdersPage">
      <h1 className="u-heading">Заказы на карте</h1>
      <OrdersPageTopMenu />
      
      <ActiveOrdersOnMap />
      
    </div>
  )
}